import { ProductVersionColumns } from '@/enums/global/ProductVersionColumns';

// Escape CSV values that contain special characters
export function escapeCsvValue(value: string): string {
    // Ensure values with commas, semicolons, quotes, or newlines are properly escaped
    if (value.includes(',') || value.includes(';') || value.includes('"') || value.includes('\n')) {
        // Escape double quotes by doubling them and wrap in quotes
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
}

// Generate CSV content from the data
function generateCSV(data: any[], ignoreColumns: string[] = [], isProductVersion: boolean) {
    if (!data || data.length === 0) {
        return '';
    }

    // Step 1: Determine the headers
    const headers = Object.keys(data[0]).filter((key) => !ignoreColumns.includes(key));

    // Step 2: Create header row with proper column names
    let csvContent = '';
    if (isProductVersion) {
        // Use translated column names for headers
        const headerRow = headers
            .map((key) => {
                const headerValue = ProductVersionColumns[key as keyof typeof ProductVersionColumns] || key;
                return escapeCsvValue(headerValue);
            })
            .join(';');
        csvContent += headerRow + '\r\n';
    }

    // Step 3: Add data rows
    data.forEach((item) => {
        const row = headers
            .map((key) => {
                // Ensure values with commas are properly quoted
                const value = item[key] === null || item[key] === undefined ? '' : String(item[key]);
                return escapeCsvValue(value);
            })
            .join(';');

        csvContent += row + '\r\n';
    });

    return csvContent;
}

// Create download link for CSV file
export function downloadCSV(csvContent: string, fileName: string) {
    // Add BOM for Excel to properly detect UTF-8 encoding
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up to avoid memory leaks
}

// Generate CSV and trigger download
export function downloadExcelFile(
    data: any[],
    fileName: string = 'products',
    ignoreColumns: string[] = [],
    isProductVersion = true
) {
    if (!data || data.length === 0) {
        console.error('No data provided for CSV export');
        return;
    }

    const csvContent = generateCSV(data, ignoreColumns, isProductVersion);
    downloadCSV(csvContent, fileName);
}
